import React, {CSSProperties, FC, memo} from "react";
import {CardContainer, CardContext, CardContextImg} from "./CardStyle";
import {useNavigate} from "react-router-dom";
import backArrow from "../../image/uparrow_arriba_1538.png"
import {config} from "../../config";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {actions} from "../../store/sliceFiles";

type CardBackProps = {
    parentId?: number
    style?: CSSProperties | undefined;

}

const CardBack: FC<CardBackProps> = (props) => {

    const {parentId} = props

    const nav = useNavigate();
    const dispatch = useDispatch<AppDispatch>();


    const navigation = () => {
        if (parentId !== undefined) {
            nav(`${config.uiStart}/${parentId}`)
        } else {
            nav(-1)
        }
        dispatch(actions.clearFile())

    }

    const click = (event: React.MouseEvent<HTMLElement>) => {
        navigation()

    }
    const touch = (event: React.TouchEvent<HTMLElement>) => {
        navigation()
    }

    return (
        <CardContainer cheked={false}
            onClick={click}
            // onTouchEnd={touch}
        >
            <CardContext>
                    <CardContextImg image={backArrow}/>
            </CardContext>
        </CardContainer>
    )

}

export default memo(CardBack)
